import FormPasswordRestore from './FormPasswordRestore';

export default FormPasswordRestore;



// WEBPACK FOOTER //
// ./src/components/Login/FormPasswordRestore/index.js